import React, { Component } from 'react'
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import './index.css'

class AlertList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            url: '',
            token: '',
            encodingAESKey: '',
            corp_id: '',
            set_corp: false,
            loadSuccess: !1,
            enterCorpId: !1
        }
        this.corpid = React.createRef()
    }

    componentDidMount() {
        React.axios('/qyweixin/call_back_setting').then(res => {
            const e = res.data;
            // console.log(e)
            if (e.errcode === 0) {
                this.setState({
                    url: e.data.url,
                    token: e.data.token,
                    corp_id: e.data.corp_id,
                    enterCorpId: !1,
                    set_corp: e.data.set_corp,
                    loadSuccess: !0,
                    encodingAESKey: e.data.encodingAESKey,
                })
            } else if (e.errcode === 1) {
                this.setState({
                    enterCorpId: !0,
                    loadSuccess: !0,
                })
            }
        }).catch(res => {

        })
    }

    handleCopy = (event) => {
        const spanText = event.target.value;
        const oInput = document.createElement('input');
        oInput.value = spanText;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象
        document.execCommand('Copy'); // 执行浏览器复制命令
        oInput.className = 'oInput';
        oInput.style.display = 'none';
        document.body.removeChild(oInput);
        tipAlert({
            type: "success",
            msg: React.language('app.edit.copy.success')
        });
    };

    onOk = () => {
        React.axios('/qyweixin/set_corp', {
            corp_id: this.corpid.current.value
        }).then(res => {
            if (res.errcode === 0) {
                tipAlert({
                    type: "success",
                    msg: React.language('saveInfo.success')
                })
            }
        }).catch(res => {

        })
        this.closeAlter()
    }

    editCorpId = () => {
        this.setState({
            enterCorpId: !0,
            loadSuccess: !0,
        })
    }

    closeAlter = () => {
        this.props.onRemoveRoot()
    }
    render() {
        const { url, token, encodingAESKey, enterCorpId, loadSuccess, corp_id, set_corp } = this.state
        const { title, styleCss } = this.props
        return (
            <div className={"content " + window.mode} style={styleCss}>
                {loadSuccess && <>
                    <div className="dialog-header">
                        <span className="title">{title}</span>
                        <i onClick={this.closeAlter} className="icon-close-large" />
                    </div>
                    <div className="dialog-body">
                        <div className="set-content">
                            <a className="DDGuide-url"
                                target="_blank"
                                href={window.rootDirectroy + "/qyweixin/manage_config"}
                                rel="noreferrer"
                                dangerouslySetInnerHTML={{ __html: React.language('corp.dingtalk.Step.help') }} />
                            <div className="DDGuide-line" />
                            {!enterCorpId ? <div className="set-app">
                                <div className="step-title"
                                    dangerouslySetInnerHTML={{ __html: React.language('corp.qyweixin.Step.title.tip') }} />
                                <div className="step-cont">
                                    <div className="step-item">
                                        <div className="stepTitle">URL</div>
                                        <input value={url} readOnly="" type="text" className="stepText"
                                            onClick={this.handleCopy} />
                                    </div>
                                    <div className="step-item">
                                        <div className="stepTitle">Token</div>
                                        <input value={token} readOnly="" type="text" className="stepText"
                                            onClick={this.handleCopy} />
                                    </div>
                                    <div className="step-item">
                                        <div className="stepTitle">EncodingAESKey</div>
                                        <input value={encodingAESKey} readOnly="" type="text" className="stepText"
                                            onClick={this.handleCopy} />
                                    </div>
                                </div>
                                {set_corp && <div className="editCorpId">
                                    <div className="editBtn" onClick={this.editCorpId}>
                                        <span>{React.language('corpid.edit')}</span>
                                    </div>
                                </div>}
                            </div> : <div className="enterCorpId">
                                <div className="step-title">{React.language('corpid.Enter.title')}</div>
                                <input type="text" defaultValue={corp_id} placeholder={React.language('corpid.Enter.inputTip')} className="corpid" ref={this.corpid} />

                            </div>}
                        </div>
                    </div>
                    {enterCorpId && <div className="dialog-footer">
                        <div className="enterBtn">
                            <div className="cancelBtn btn" onClick={this.closeAlter}>
                                <span>
                                    {React.language("cancel")}
                                </span>
                            </div>
                            <div className="okBtn btn" onClick={this.onOk}>
                                <span>
                                    {React.language("ok")}
                                </span>
                            </div>
                        </div>
                    </div>}
                </>}
            </div>
        )
    }
}

export default AlertList